import axios from "axios";
import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { AppConfig } from "_config/AppConfig";

const cookies = new Cookies();

const getStorageItem = (key) => {
  if (AppConfig.AUTH_STORE_IN_COOKIE === true) {
    return cookies.get(key);
  }
  else {
    return localStorage.getItem(key);
  }
}

const setStorageItem = (key, value, expirationDate) => {
  removeStorageItem(key);
  if (AppConfig.AUTH_STORE_IN_COOKIE === true) {
    cookies.set(key, value, {
      path: "/",
      expires: expirationDate,
    });
  }
  else {
    localStorage.setItem(key, value);
  }
}

const removeStorageItem = (key) => {
  cookies.remove(key);
  localStorage.removeItem(key);
}

export function getAccessToken() {
    const token = getStorageItem(AppConfig.AUTH_TOKEN_KEY);
    return token;
}

const withAuth = (HocComponent) => (props) => {

    const [state, setState] = useState({
      isAuthenticated: false,
      refreshTokenIntervalId: null,
      hasError: false,
      errorMessage: null,
    });

    const Authenticate = async () => {
        const accessToken = await GetAccessToken();
    
        clearInterval(state.refreshTokenIntervalId);
        if (accessToken) {
          var refreshTokenIntervalId = setInterval(async () => {
            
            const exparationDate = new Date(
              getStorageItem(AppConfig.AUTH_TOKEN_EXPIRATION_KEY)
            );
            if (!exparationDate || exparationDate < new Date()) {
              const refreshedToken = await GetAccessToken();
              if (!refreshedToken) {
                clearInterval(state.refreshTokenIntervalId);
                setState({
                  ...state,
                  isAuthenticated: false,
                  refreshTokenIntervalId: null,
                  hasError: true,
                  errorMessage: "Service unavailable...",
                });
              }
            }

          }, 60000);
      
          setState({
            ...state,
            isAuthenticated: true,
            refreshTokenIntervalId,
          });
        }
        else {
            setState({
              ...state,
              isAuthenticated: false,
              refreshTokenIntervalId: null,
              hasError: true,
              errorMessage: "Service unavailable...",
            });
        }
    };

    const GetAccessToken = async (save = true) => {

        let accessToken = getStorageItem(AppConfig.AUTH_TOKEN_KEY);
        let expirationDate = new Date(getStorageItem(AppConfig.AUTH_TOKEN_EXPIRATION_KEY));
        if (accessToken && expirationDate && expirationDate > new Date()) {
            return accessToken;
        }
    
        var accessTokenResponse = null;
        try {
          const tokenClient = axios.create({
            baseURL: AppConfig.SERVICE_BASE_URL,
          });
        
          const tokenClientHeaders = {...tokenClient.defaults.headers};
          tokenClientHeaders['Authorization'] = `Basic ${AppConfig.AUTH_API_KEY}`;
          tokenClient.defaults.headers = tokenClientHeaders;
  
          accessTokenResponse = await tokenClient.post('token');
        } catch (error) {
          console.log(error);
        }
    
        accessToken = accessTokenResponse?.data?.accessToken;
        const expiresOn = accessTokenResponse?.data?.expiresOn;
        if (save) {
          if (accessToken && expiresOn) {
            const expirationDate = new Date(new Date(expiresOn).getTime() - (5 * 60 * 1000));
    
            setStorageItem(AppConfig.AUTH_TOKEN_KEY, accessToken, expirationDate);
            setStorageItem(AppConfig.AUTH_TOKEN_EXPIRATION_KEY, expirationDate, expirationDate);
          }
          else {
            removeStorageItem(AppConfig.AUTH_TOKEN_KEY);
            removeStorageItem(AppConfig.AUTH_TOKEN_EXPIRATION_KEY);
          }
        }

        return accessToken;
    };

    const SignIn = async () => {
        await Authenticate();
    }
    
    useEffect(() => {
      SignIn();
    }, []);

    if (state.isAuthenticated)
    {
        return (
          <HocComponent
            {...props}
            auth={state}
          />
        );
    }
      
    if (state.hasError) {
        return <div>{state.errorMessage}</div>;
    }
    
    return (
        <div>
          <LoadingSpinner />
        </div>
      );
};

export default withAuth;